export default [
    {
        path: 'familias/',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'FamiliaController' }
    }, {
        path: 'familias/add',
        component: require('./Add').default,
        meta: { middleware: 'auth', controller: 'FamiliaController' }
    }, {
        path: 'familias/edit/:id/:aba?',
        name: 'familias_edit',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'FamiliaController' },
    }, {
        path: 'familias/show/:id',
        component: require('./Show').default,
        meta: { middleware: 'auth', controller: 'FamiliaController' }
    },
    {
        path: 'relatorios/familias',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/familias/home',
        meta: { middleware: 'auth', controller: 'FamiliaController' },
        children: [
            {
                path: 'home',
                name: "relatorios_home_familias",
                component: require('./reports/includes/Home').default,
                meta: { middleware: 'auth', controller: 'FamiliaController' },
            },
            {
                path: 'graficos',
                name: "graficos_familias",
                component: require('./reports/includes/Graficos').default,
                meta: { middleware: 'auth', controller: 'FamiliaController' },
            },

        ]
    }
];


